import NiceModal from "@ebay/nice-modal-react";
import {CustomDialog, Text} from "@bounce/shared/ui";

type Props = {
  templateCount: number;
  onConfirm: (deleteTranslations: boolean) => void;
};

const DeleteTranslationDialog = NiceModal.create(({templateCount, onConfirm}: Props) => (
  <CustomDialog
    title="Delete translation?"
    forceTitle
    buttonText="Delete translation"
    secondaryButtonText="Keep translation"
    onClick={() => onConfirm(true)}
    onClickSecondary={() => onConfirm(false)}
    width="380px"
  >
    <Text size={14}>
      {templateCount > 1
        ? "Some of the selected templates have a Spanish translation. Delete it too, or keep it as a standalone template?"
        : "This template has a Spanish translation. Delete it too, or keep it as a standalone template?"}
    </Text>
  </CustomDialog>
));

export default DeleteTranslationDialog;
